<template lang="pug">
v-dialog(v-model="dialog", width="800")
  template(v-slot:activator="{ on }")
    v-btn.specialBtn.search(v-on="on", @click="$emit('click')") 
      v-icon mdi-chart-bar
  v-card
    .pa-4
      section.py-1.mt-2
        h3.mb-2 Informations générales
        v-text-field(
          v-model="title",
          label="Nom de la parcelle",
          color="secondary"
        )
        v-textarea(
          v-model="description",
          label="Infos",
          outlined,
          hide-details,
          color="secondary"
        )

      section.py-1.mt-2
        h3.mb-2 Résultats des prélèvements
        v-chip.ma-1(
          close,
          close-icon="mdi-delete",
          v-for="(data, index) in datas",
          :key="'data' + index",
          @click:close="remove(data)"
        ) 
          strong {{ data[1] }}
          span &nbsp;- {{ data[0] }}
        v-chip.ma-1(
          @click="addPrelevement = true",
          v-if="!addPrelevement",
          color="secondary"
        ) 
          v-icon mdi-plus
          strong Ajouter un prélevement
      section.py-1.mt-1(v-if="addPrelevement")
        .newPrelevement.pa-3
          h4.mb-2 Information du prélèvement
          v-menu(
            ref="menu",
            v-model="menu",
            :close-on-content-click="false",
            :return-value.sync="picker",
            min-width="auto"
          )
            template(v-slot:activator="{ on, attrs }")
              v-text-field(
                v-model="picker",
                label="Date de la mesure",
                readonly,
                v-bind="attrs",
                v-on="on",
                outlined,
                hide-details,
                dense,
                color="secondary"
              )
            v-date-picker(
              v-model="picker",
              scrollable,
              color="secondary",
              show-adjacent-months
            )
              v-btn(color="secondary", @click="$refs.menu.save(picker)", block) Enregistrer la date
          v-text-field.mt-2(
            v-model="mesure",
            type="number",
            label="Valeur du prélèvement",
            outlined,
            hide-details,
            dense,
            color="secondary"
          )
          v-flex
            v-btn.mt-2.mr-2(@click="addPrelevement = false") Annuler
            v-btn.mt-2(@click="setMesure", color="secondary") Ajouter
      section.py-1.mt-2(v-if="datas.length > 0")
        h3.mb-2 Graphique
        Graph(
          :datas="datas",
          v-if="datas.length > 0",
          :graphTitle="graphTitle",
          :graph-unit="graphUnit",
          :enableLogScale="enableLogScale",
          :enableScientificNumber="enableScientificNumber",
          :maxValue="maxValue",
          :seuil1="seuil1",
          :seuil2="seuil2"
        )
      section.py-1.mt-2(v-if="datas.length > 0")
        h3.mb-2 Personnalisation du graphique

        v-text-field(
          v-model="graphTitle",
          label="Titre du graphique",
          outlined,
          hide-details,
          dense,
          color="secondary"
        )

        v-form
          .mt-2
            v-layout
              v-text-field.mr-2(
                v-model="graphUnit",
                label="Unité",
                outlined,
                hide-details,
                dense,
                color="secondary"
              )
              v-text-field.mr-2(
                v-model="seuil1",
                type="number",
                label="seuil 1 (bleu)",
                outlined,
                hide-details,
                dense,
                color="secondary"
              )
              v-text-field.mr-2(
                v-model="seuil2",
                type="number",
                label="seuil 2 (rouge)",
                outlined,
                hide-details,
                dense,
                color="secondary"
              )
              v-text-field(
                v-model="maxValue",
                type="number",
                label="Max graphique",
                outlined,
                hide-details,
                dense,
                color="secondary"
              )

          .mt-2
            v-switch(
              v-model="enableLogScale",
              label="Echelle logarythmique",
              hide-details,
              dense,
              color="secondary"
            )
            v-switch(
              v-model="enableScientificNumber",
              label="Affichage scientifique",
              hide-details,
              dense,
              color="secondary"
            )

      section.py-1.mt-2
        v-btn(@click="save", color="primary", block) Enregistrer
</template>


<script>
import _ from "lodash";

import Graph from "./Graph";

export default {
  name: "ParcelleEditor",
  components: {
    Graph,
  },
  data: () => {
    return {
      menu: false,
      dialog: false,
      loading: false,
      mesure: null,
      addPrelevement: false,
      //datas: [],
      title: "title",
      description: "",
      graphTitle: "Type de prélèvement",
      graphUnit: "Unité",
      enableLogScale: false,
      enableScientificNumber: false,
      maxValue: 5,
      seuil1: 0.5,
      seuil2: 2.5,
      picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      mesures: {},
    };
  },
  props: ["currentParcelleId", "parcelles"],
  //mounted() {
  //  this.description = this.
  //},
  methods: {
    save() {
      this.$emit("update", {
        title: this.title,
        description: this.description,
        graphTitle: this.graphTitle,
        graphUnit: this.graphUnit,
        enableLogScale: this.enableLogScale,
        enableScientificNumber: this.enableScientificNumber,
        maxValue: this.maxValue,
        seuil1: this.seuil1,
        seuil2: this.seuil2,
        datas: JSON.stringify(this.mesures),
      });
      this.dialog = false;
    },
    setMesure() {
      this.mesures[this.picker] = parseFloat(this.mesure);
      this.updateMesures();
      this.addPrelevement = false;
    },
    sortMesures() {
      this.mesures = _.fromPairs(
        _.sortBy(_.toPairs(this.mesures), ([date, value]) => date)
      );
    },
    remove(data) {
      delete this.mesures[data[0]];
      this.mesure = null;
      this.updateMesures();
    },
    removeMesure() {},
    updateMesures() {
      this.sortMesures();
    },
    set(data) {
      if (data) {
        this.picker = data[0];
        this.mesure = data[1];
      } else {
        this.picker = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);
        this.mesure = "";
      }
    },
  },
  watch: {
    dialog() {
      this.title = _.get(this.parcelles[this.currentParcelleId], "infos.title");
      this.description = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.description"
      );
      this.graphTitle = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.graphTitle"
      );
      this.enableLogScale = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.enableLogScale"
      );
      this.enableScientificNumber = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.enableScientificNumber"
      );
      this.maxValue = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.maxValue"
      );
      this.seuil1 = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.seuil1"
      );
      this.seuil2 = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.seuil2"
      );
      this.graphUnit = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.graphUnit"
      );
      const saveDatas = _.get(
        this.parcelles[this.currentParcelleId],
        "infos.datas"
      );
      this.mesures = {};
      if (saveDatas) {
        this.mesures = JSON.parse(saveDatas);
        this.updateMesures();
      }
    },
    picker() {
      this.mesure = this.mesures[this.picker] || null;
    },
  },
  computed: {
    datas() {
      const datas = [];
      _.each(this.mesures, (data, index) => {
        datas.push([index, data]);
      });
      return datas;
    },
  },
};
</script>
<style lang="stylus" scoped>
.details, .newPrelevement {
  background: #eee;
  border-left: #00b4e2 5px solid;
}

h3 {
  color: #13286b;
}
</style>

